import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import RejectEmail from './pages/RejectEmail';
import Footer from './components/Footer';
import Header from './components/Header';
import Productintro from './pages/Product';
import ProductHO from './pages/ProductHO';
import ProductZC from './pages/ProductZC';
import ProductOIT from './pages/ProductOIT';
import Product1K from './pages/Product1K';
import ProductMOB from './pages/ProductMOB';
import Referance from './pages/Referance';
import CompanyLocation from './pages/CompanyLocation';
import ContactUse from './pages/ContactUse';
import CompanyAbout from './pages/CompanyAbout';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

// 언어 컨텍스트를 사용하는 래퍼 컴포넌트
function AppRoutes() {
  const { lang } = useLanguage();

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/reject-email" element={<RejectEmail />} />
      <Route path="/contactuse" element={<ContactUse lang={lang}/>} />
      <Route path="/product" element={<Productintro lang={lang}/>} />
      <Route path="/product/halcyon" element={<ProductHO lang={lang}/>} />
      <Route path="/product/primx-zc" element={<ProductZC lang={lang}/>} />
      <Route path="/product/proofpoint-oit" element={<ProductOIT lang={lang}/>} />
      <Route path="/product/1kosmos" element={<Product1K lang={lang}/>} />
      <Route path="/product/mobileum" element={<ProductMOB lang={lang}/>} />
      <Route path="/referance" element={<Referance lang={lang}/>} />
      <Route path="/company/location" element={<CompanyLocation lang={lang}/>} />
      <Route path="/company/about" element={<CompanyAbout lang={lang} />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Header />
        <main style={{ marginTop: '100px' }}>
          <AppRoutes />
        </main>
        <Footer />
      </Router>
    </LanguageProvider>
  );
}

export default App;
